import AppForm from "../app-components/Form/AppForm";

Vue.component('profile-edit-profile-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                email:  '' ,
                password:  '' ,
                first_name:  '' ,
                last_name:  '' ,
                language:  '' ,

            }
        }
    },
    methods: {
        onSuccess(data) {
            if(data.notify) {
                this.$notify({ type: data.notify.type, title: data.notify.title, text: data.notify.message});
            } else if (data.redirect) {
                window.location.replace(data.redirect);
            }
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/profile-edit-profile/Form.js